import React, {useState} from 'react';

const Context = React.createContext ({});

export function ProductsContextProvider({children}){
    const [products, setProducts] = useState(null);
    const [cantProdView, setCantProdView] = useState(6);
    const [category, setCategory] = useState('');
    const [scrollTop, setScrollTop] = useState(0);
    const [sizes, setSizes] = useState("");
    return (
    <Context.Provider value={{products, setProducts, cantProdView, setCantProdView, category, setCategory, scrollTop, setScrollTop, sizes, setSizes}}>
        {children}
    </Context.Provider>
    );
}

export default Context;